import { generateUUID } from 'services/base/uuid';
import { UnreachableFunction } from 'ui/base/types';

import {
  SiteFilterType,
  DomainSiteFilter,
  AddressSiteFilter,
  RangeSiteFilter,
  NetworkSiteFilter,
  SiteFilter,
} from 'services/pangolin/types';

import Messages from './site_entry_messages';

export type FilterIconStyles = {
  domainIcon: string;
  hostIcon: string;
  networkIcon: string;
};

export const getSiteFilterIcon = (styles: FilterIconStyles, entry: SiteFilter): string | undefined => {
  switch(entry.type) {
    case SiteFilterType.DOMAIN:
      return styles.domainIcon;
    case SiteFilterType.ADDRESS:
      return styles.hostIcon;
    case SiteFilterType.RANGE:
    case SiteFilterType.NETWORK:
      return styles.networkIcon;
    default:
      return UnreachableFunction(entry);
  }
};

export const getSiteFilterLabel = (entry: SiteFilter, option?: boolean): string => {
  switch(entry.type) {
    case SiteFilterType.DOMAIN:
      if (option) return Messages.domainOption();
      return entry.domain;
    case SiteFilterType.ADDRESS:
      if (option) return Messages.addressOption();
      return entry.address;
    case SiteFilterType.RANGE:
      if (option) return Messages.rangeOption();
      return `${entry.first} — ${entry.final}`;
    case SiteFilterType.NETWORK:
      if (option) return Messages.networkOption();
      return `${entry.address} / ${entry.mask}`;
    default:
      return UnreachableFunction(entry);
  }
};

export const getSiteFilterID = (entry: SiteFilter): string => {
  return entry.uuid;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function createSiteFilterOptions(existingEntries: SiteFilter[]): SiteFilter[] {
  return [{
    type: SiteFilterType.DOMAIN,
    uuid: generateUUID(),
    domain: '',
  }, {
    type: SiteFilterType.ADDRESS,
    uuid: generateUUID(),
    address: '',
  }, {
    type: SiteFilterType.RANGE,
    uuid: generateUUID(),
    first: '',
    final: '',
  }, {
    type: SiteFilterType.NETWORK,
    uuid: generateUUID(),
    address: '',
    mask: 0,
  }];
}

export function createDomainFilter(domain: string): DomainSiteFilter {
  return {
    type: SiteFilterType.DOMAIN,
    uuid: generateUUID(),
    domain,
  };
}

export function createAddressFilter(address: string): AddressSiteFilter {
  return {
    type: SiteFilterType.ADDRESS,
    uuid: generateUUID(),
    address,
  };
}

export function createRangeFilter(first: string, final: string): RangeSiteFilter {
  return {
    type: SiteFilterType.RANGE,
    uuid: generateUUID(),
    first, final,
  };
}

export function createNetworkFilter(address: string, mask: number): NetworkSiteFilter {
  return {
    type: SiteFilterType.NETWORK,
    uuid: generateUUID(),
    address, mask,
  };
}
